/* eslint-disable no-restricted-globals */
/**
 * @description
 */

/* global ModuloTS */

(() => {
	// VARS
	const mainSearch = {
		root: document.querySelector('#block-spe-main-search-form'),
		submit: document.querySelectorAll('input[type=submit]'),
		input: document.querySelectorAll('input[type=text]'),
		title: document.querySelectorAll('.facets-links--title'),
		categ: document.querySelector(
			'#views-exposed-form-news-solr-block-news-solr'
		),
	};

	// FUNCTIONS

	/**
	 * @description
	 * Gestion des classes dynamiques
	 */

	const mainSearchClasses = () => {
		if (mainSearch.submit && typeof mainSearch.submit !== 'undefined') {
			mainSearch.submit.forEach((submit) => {
				submit.classList.remove('form-control-lg', 'form-control');
				submit.classList.add('btn', 'btn-primary');
			});
		}
	};

	const mainSearchInput = () => {
		if (mainSearch.input && typeof mainSearch.input !== 'undefined') {
			mainSearch.input.forEach((input) => {
				input.setAttribute('placeholder', ModuloTS['I search']);
			});
		}
	};

	const mainSearchIcons = () => {
		document.querySelectorAll('.facets-links--title').forEach((item) => {
			const insertLabelIcon = (name, icon) => {
				if (item.innerText.toLowerCase() === name) {
					item.insertAdjacentHTML(
						'afterbegin',
						`<div class="view-filters__fieldset__icon"><i data-icon="${icon}"></i></div>`
					);
				}
			};

			// Ajoute les icons a côté des legends -> AJOUTER LA LÉGENDE EN MINUSCULE
			insertLabelIcon('type de contenu', 'doc');
			insertLabelIcon('date de publication', 'calendar');
			insertLabelIcon('mots clés', 'keyword');
		});
	};

	const checkCategories = () => {
		const OldXHR = window.XMLHttpRequest;

		const newXHR = () => {
			const realXHR = new OldXHR();
			realXHR.addEventListener(
				'readystatechange',
				function () {
					if (realXHR.readyState === 4 && realXHR.status === 200) {
						afterAjaxComplete();
					}
				},
				false
			);
			return realXHR;
		};

		window.XMLHttpRequest = newXHR;

		const afterAjaxComplete = () => {
			const queryString = window.location.search;
			if (queryString !== '') {
				document.body.classList.add('actus-categ');
			} else {
				document.body.classList.remove('actus-categ');
			}
		};
	};

	const init = () => {
		mainSearchClasses();
		mainSearchIcons();
		mainSearchInput();
	};

	// GO 🚀
	if (document.body.contains(mainSearch.root)) {
		window.addEventListener('load', function () {
			init();
		});
	}

	if (document.body.contains(mainSearch.categ)) {
		checkCategories();
	}
})();
